import { MapPin, Truck } from 'lucide-react';

import { COMMERCE, CONTACT, SITE } from '@/config/site';
import { formatCurrency } from '@/lib/format';
import { WA_LINKS } from '@/lib/whatsapp';

import { Container } from '../common/Container';
import { WhatsAppIcon } from '../common/icons';

/** Thin utility strip above the header: shipping promise and direct contact. */
export function AnnouncementBar() {
  return (
    <div className="hidden bg-brown-900 py-2 text-xs text-cream-300 lg:block">
      <Container className="flex items-center justify-between gap-6">
        <p className="flex items-center gap-2">
          <Truck className="size-4 shrink-0 text-caramel-400" aria-hidden="true" />
          <span>
            Entrega <strong className="text-cream-100">grátis</strong> em pedidos acima de{' '}
            <strong className="text-cream-100">
              {formatCurrency(COMMERCE.freeShippingThreshold)}
            </strong>
          </span>
        </p>

        <div className="flex items-center gap-6">
          <p className="flex items-center gap-2">
            <MapPin className="size-4 shrink-0 text-caramel-400" aria-hidden="true" />
            {SITE.serviceArea}
          </p>

          <a
            href={WA_LINKS.general}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-semibold transition-colors hover:text-cream-100"
          >
            <WhatsAppIcon className="size-4 text-whats-400" />
            {CONTACT.whatsappDisplay}
          </a>
        </div>
      </Container>
    </div>
  );
}
